<div fxLayout="row">
    <mat-button-toggle-group #group="matButtonToggleGroup">
        <mat-button-toggle class="boundary-time-button" *ngFor="let boundaryTime of boundaryTimes; let i=index" [value]="boundaryTime"
            [checked]="boundaryTime.isSame(selectedBoundaryTime)" (click)="moveToTime(boundaryTime)">
            <span *ngIf="i == 0" class="boundary-time-label">EOD</span>
            <span *ngIf="i > 0"class="boundary-time-label">{{boundaryTime.format('HH:mm')}}</span>
        </mat-button-toggle>
    </mat-button-toggle-group>
</div>